import React, { FC, useEffect, useState } from "react";

const INTERVAL = 500;

interface LoadingAnimationProps {
  text?: string;
  className?: string;
}

export const LoadingAnimation: FC<LoadingAnimationProps> = ({
  text,
  className,
}) => {
  const [dotsLength, setDotsLength] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setDotsLength((dotsLength + 1) % 4),
      INTERVAL
    );

    return () => clearInterval(interval);
  });

  return (
    <span className={className}>
      {text}
      <span className="loading-animation-dots-container">
        {".".repeat(dotsLength)}
      </span>
    </span>
  );
};
